<main class="e404">
  <h1>404 ERROR</h1>
  <a class="btn btn-primary" href="/">Return to home</a>
</main>

<style lang="scss">
  .e404 {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
</style>
